import React from 'react';
import './Tables.css';
import Text from '../Text/Text';
import classNames from 'classnames';
import Pagination, { PaginationProps } from '../Pagination/Pagination';
import formatHands from '../../utils/formatHands';
import { EyeInvisibleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

type Props = {
  columns: Array<{
    title: string;
    dataIndex: string;
    render?: (x: any, index: number) => React.ReactNode;
  }>;
  data: Array<any>;
  spaceIndexes?: Array<number>;
  pagination: PaginationProps | false;
};

const getSubscriptionLabel = (limit: number) => {
  if (limit > 200) return 'Unlim';
  if (limit > 50) return '10-200';
  if (limit > 25) return '10-50';
  return '10-25';
};

const Table = React.memo(({ columns, data, spaceIndexes, pagination }: Props) => {
  const { t } = useTranslation('translation');

  return (
    <div className="Table__Wrapper">
      <table className="Table">
        <thead>
          <tr>
            {columns.map((x, index) => (
              <th className="Table--th" key={index}>
                <Text>{x.title}</Text>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="Table--tbody">
          {data.map((x, index) =>
            !x.specialRow ? (
              <tr
                key={index}
                className={classNames({
                  'Table--tr-space': spaceIndexes && spaceIndexes.includes(index),
                })}
              >
                {columns.map((c) => (
                  <td className="Table--td" key={c.dataIndex}>
                    {c.render ? c.render(x, index) : <Text>{x[c.dataIndex]}</Text>}
                  </td>
                ))}
              </tr>
            ) : (
              <tr key={x.limit}>
                <td className="Table--td">
                  <Text>NL{x.limit}</Text>
                </td>
                <td className="Table--td">
                  <Text>{formatHands(x.hands, 1)}</Text>
                </td>
                <td className="Table--td" colSpan={5}>
                  <Text>
                    <EyeInvisibleOutlined /> {t('subscription')} {getSubscriptionLabel(x.limit)}
                  </Text>
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>
      {pagination && <Pagination {...pagination} />}
    </div>
  );
});

export default Table;
